<setting-status>
	<div class="wrapper page">
		<section class="page_wrap" style="margin-bottom: 150px" if={state.data.debt_plan}>
			<div class="page_inner unpaid">
				<h1 class="main_title page">重要なご連絡</h1>
				<div class="unpaid_wrap">
					<p class="unpaid_msg">ご利用分のお支払いがエラーにより完了していないため、<span class="emphasis">サービスのご利用を停止</span>しております。</p>
					<div class="unpaid_contents">
						<h2 class="unpaid_title">料金未払いの詳細</h2>
						<p class="plan_name">{state.data.debt_note}</p>
					</div><!--/.unpaid_contents-->
					<div class="plan_button_wrap">
						<div class="button button-secondary button-plan"><a class="" onclick="{ (e) => payOffDebt(e) }">未払の料金を支払う</a></div>
					</div><!--/.plan_button_wrap-->
					<p class="unpaid_msg">※お支払いが完了しましたらフリープランの状態になりますので、引き続き有料プランをご利用されたい場合は改めて有料プランをご契約ください。</p>
				</div><!--/.unpaid_wrap-->
			</div>
		</section>

		<section class="page_wrap">
			<div class="page_inner">
				<h1 class="main_title page">現在ご利用中のプラン</h1>
				<div class="plan_wrap">
					<div class="plan_heading">
						<h2 class="plan_title">プラン名</h2>
						<div class="plan_contents">
							<p class="plan_name">{state.data.plan.name}</p>
							<p class="plan_explanation"><a href="/plan" class="link_outer" target="_blank" is="link-outer">プランに関するご説明はこちら</a></p>
							
							<div class="plan_button_wrap">
								<div if={!state.data.debt_plan && state.data.mode=='user' && !state.data.plan_change_reservation} class="button button-secondary button-plan js-modal-open" data-target="plan-modal"><a class="" onclick="{ (e) => onOpenModal(e, 'plan-modal') }">プラン変更</a></div>
								<button if={!state.data.debt_plan && state.data.mode=='user' && state.data.ticket_buyable} class="button button-tertiary button-count js-modal-open" type="button" value="カウント追加購入" data-target="oneshot-modal" onclick="{ (e) => onOpenModal(e, 'oneshot-modal') }">カウント追加購入</button>
							</div><!--/.plan_button_wrap-->
						</div>
					</div>
					<dl class="plan_detail">
						<dt class="plan_detail-title">月間基本ご利用可能カウント</dt>
						<dd class="plan_detail-content"><span class="emphasis">{state.data.plan.tickets.toLocaleString()}</span></dd>
						<dt class="plan_detail-title">月額</dt>
						<dd class="plan_detail-content">{state.data.plan.price.toLocaleString()}円 (税込)</dd>
						<template if={state.data.mode=='user'}>
						<dt class="plan_detail-title">今月の追加オーダー数合計</dt>
						<dd class="plan_detail-content">{state.data.oneshot_count_in_this_month}回</dd>
						</template>
						<dt class="plan_detail-title">ご利用開始</dt>
						<dd class="plan_detail-content">{state.data.current_plan_created_at}</dd>
					</dl><!--/.plan_detail-->
				</div><!--/.plan_wrap-->
			
            <template if={state.data.plan_change_reservation}>
				<h1 class="main_title page">来月からご利用いただくプラン</h1>
				<div class="plan_wrap">
					<div class="plan_heading">
						<h2 class="plan_title">プラン名</h2>
						<div class="plan_contents">
							<p class="plan_name">{state.data.plan_change_reservation.name}</p>
						</div>
					</div>
					<dl class="plan_detail">
						<dt class="plan_detail-title">月間基本ご利用可能カウント</dt>
						<dd class="plan_detail-content"><span class="emphasis">{state.data.plan_change_reservation.tickets}</span></dd>
						<dt class="plan_detail-title">月額</dt>
						<dd class="plan_detail-content">{state.data.plan_change_reservation.price}円 (税込)</dd>
						<dt class="plan_detail-title">ご利用開始予定月</dt>
						<dd class="plan_detail-content">{state.data.plan_change_reservation.startTime}</dd>
					</dl><!--/.plan_detail-->
				</div><!--/.plan_wrap-->
            </template>
				
			<template if={state.data.mode=='user'}>
				<h1 class="main_title page">ご利用履歴</h1>
				<div class="plan_wrap">
					<div class="plan_heading">
						<h2 class="plan_title">プラン変更履歴</h2>
					</div>
					<dl class="plan_detail">
                        <template each={ item in state.data.plan_history}>
                            <dt class="plan_detail-title history">{item.created_at}</dt>
                            <dd class="plan_detail-content">{item.name}</dd>
                        </template>
					</dl><!--/.plan_detail-->
				</div><!--/.plan_wrap-->
			</template>

				<div class="plan_wrap last" if={state.data.mode=='user' && state.data.oneshot_history.length > 0}>
					<div class="plan_heading">
						<h2 class="plan_title">追加オーダー履歴</h2>
					</div>
					<dl class="plan_detail">
                        <template each={ item in state.data.oneshot_history}>
						    <dt class="plan_detail-title history">{item.created_at}</dt>
						    <dd class="plan_detail-content">{item.tickets}回分追加</dd>
                        </template>
					</dl><!--/.plan_detail-->
				</div><!--/.plan_wrap-->
			</div><!--/.page_inner-->
		</section><!--page_wrap-->
	</div><!--/.wrapper-->
    <plan-modal modal-id="plan-modal" setting-status-api={state.api}></plan-modal>
    <oneshot-modal modal-id="oneshot-modal"></oneshot-modal>
  <script>
    import di from "dependeny-injection";
    import { api as SettingStatusApi } from "@model/setting-status.js";
    import planModal from "@tags/modal/setting/plan-modal.riot";
    import oneshotModal from "@tags/modal/setting/oneshot-modal.riot";

    export default {
        components: {
            "plan-modal": planModal,
            "oneshot-modal": oneshotModal,
        },
        state: {
            api: SettingStatusApi,
            data: {
			  debt_plan: null,
			  debt_note: null,
			  mode: 'user',
              tickets: 0,
              ticket_buyable: false,
              current_plan_created_at: null,
              oneshot_count_in_this_month: 0,
              plan: {
                name: "",
                price: "",
                tickets: 0
              },
              plan_history: [],
              oneshot_history: [],
              plan_change_reservation: null
            }
        },
        onOpenModal(e, modalId) {
            if (modalId == 'plan-modal') {
                SettingStatusApi.planModalShow();
            }
            window.$(this.$(`#${modalId}`)).fadeIn(100);
        },
        cancel(e) {
            SettingStatusApi.cancel();
        },
		payOffDebt(e) {
			SettingStatusApi.payOffDebt();
		},
        onMounted() {
            SettingStatusApi.on('fetched:items', (data) => {
                this.state.data = data;
                this.update();
				di.userStatusApi.fetch();
            });
            SettingStatusApi.on('canceled', (success, data) => {
                alert(data);
                SettingStatusApi.items();
            });
            SettingStatusApi.on('payedOffDebt', (success, data) => {
                if (!success) {
                    console.log(data);
                    alert(data);
                    return;
                }
                if (data.href) {
                    location.href = data.href;
                    return;
                };
            });
            SettingStatusApi.items();
        }
    }
  </script>
</setting-status>